import { ClientOrderSubmissionState } from '@src/orders/domain/ClientOrderSubmissionState';
import { string } from 'yup';

export const ClientOrderSubmissionStateSchema = string()
  .oneOf(Object.values(ClientOrderSubmissionState))
  .defined();
